export enum SalesDeliveryStatus {
    Draft = 0,
    Completed = 1,
    Synced = 2,
}